<template>
  <section>
    <header-component/>
    <main>
      <hero-banner/>
      <podcast-archive/>
    </main>
    <footer-component/>
  </section>
</template>

<script>
import FooterComponent from "../components/Index/FooterComponent";
import HeaderComponent from "../components/Index/HeaderComponent";
import HeroBanner from "../components/Index/HeroBanner";
import PodcastArchive from "../components/Index/PodcastArchive";

export default {
  components: {PodcastArchive, HeroBanner, HeaderComponent, FooterComponent},
  mounted() {
  }
}
</script>
